<template>
<div class="m-b-30">
  <b-row>
    <b-col cols="4">
      <b-form-select v-model="selected" :options="stores" @change="storeUpdated"></b-form-select>
      <a href=""  @click.prevent="saveAsDefault" class="saveAsDefault text-success" v-if="selected">Save as Default</a>
      
    </b-col>
  </b-row>
</div>
</template>

<script>
import StoreService from '../../services/store.service';
export default {
  data() {
    return {
      stores: [{
        value: null,
        text: 'Select a store'
      }],
      selected: null,
    }
  },
  mounted() {
    this.fetchStores();
  },
  methods: {
    fetchStores() {
      StoreService.fetchStores().then(response => {
          let company_stores = response.data.data.map(store => {
            return JSON.parse(JSON.stringify({
              value: store.id,
              text: store.identifier
            }))
          });
          this.stores = this.stores.concat(company_stores);

          if(localStorage.getItem('dashboardSelectedStore')){
              let selectedStore = JSON.parse(localStorage.getItem('dashboardSelectedStore'));
              this.storeUpdated(selectedStore.id);
              this.selected = selectedStore.id;
          }

        })
        .catch(errors => console.log(errors));
    },
    storeUpdated(id) {
      let data;
      if (id) {
        const selectedStore = this.stores.find(store => store.value == id);
        data = {
          action: 'set',
          store: {
            name: selectedStore.text,
            id: selectedStore.value
          }
        }

        // store by default 
        localStorage.setItem('dashboardSelectedStore', JSON.stringify(data.store))

      } else {
        data = {
          action: 'unset',
        }

      }
      this.$store.dispatch("ecommerceStore/setUnsetActiveStore", data)
    },
    saveAsDefault(){

      const selectedStore = this.stores.find(store => store.value == this.selected);

      let data = {
        name: selectedStore.text,
        id: selectedStore.value
      }
      
      localStorage.setItem('dashboardSelectedStore', JSON.stringify(data))

      this.$toasted.show("Updated the default store on dashboard", {
            type: "success",
            action: {
              text: "Close",
              class: "toastBtnTxt",
              onClick: (e, toastObject) => {
                toastObject.goAway(0);
              },
            },
            duration: 3000,
          });


    }
  }
}
</script>

<style lang="scss" scoped>
  .saveAsDefault{
    font-size: 13px;
    margin-top: 5px;
  }
</style>
